import { difficultiesByGameVersion } from 'app/frontend/types/custom/Difficulty'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

export const useDifficulties = () => {
  const gameVersion = useGameVersion()
  return {
    difficulties: difficultiesByGameVersion[gameVersion.id],
    defaultDifficulty: gameVersion.config.default_difficulty,
    hasDifficulties: gameVersion.has('difficulties'),
    gameVersion: gameVersion.id,
  }
}
